import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { LanguageService } from '@core/services';
import { ChatDrawerComponent } from './components/chat-drawer/chat-drawer.component';
import { ChatLogsComponent } from './components/chat-logs/chat-logs.component';
import { ChatThreadComponent } from './components/chat-thread/chat-thread.component';
import i18n from './i18n';

/**
 * The bid chat drawer (#47189). Imported by the layout, which hosts the drawer, so it carries its
 * own `bidChat` translations: the drawer can open before the shipments module ever loads.
 */
@NgModule({
  declarations: [ChatDrawerComponent, ChatLogsComponent, ChatThreadComponent],
  imports: [CommonModule, SharedModule],
  exports: [ChatDrawerComponent],
})
export class BidChatModule {
  constructor(languageService: LanguageService) {
    languageService.registerModule(i18n);
  }
}
